<script setup>
import { computed } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const page = usePage()

const props = defineProps({
  counts: { type: Object, default: () => ({}) },
})

const tabs = computed(() => [
  { key: 'vehicles',   label: t('approvals.tabs.vehicles'),   href: '/admin/approvals',          count: props.counts.vehicles   || 0 },
  { key: 'tours',      label: t('approvals.tabs.tours'),      href: '/admin/tour_approvals',     count: props.counts.tours      || 0 },
  { key: 'properties', label: t('approvals.tabs.properties'), href: '/admin/property_approvals', count: props.counts.properties || 0 },
])

const activeKey = computed(() => {
  const url = page.url
  if (url.startsWith('/admin/tour_approvals')) return 'tours'
  if (url.startsWith('/admin/property_approvals')) return 'properties'
  if (url.startsWith('/admin/approvals')) return 'vehicles'
  return null
})
</script>

<template>
  <div
    class="flex gap-1 overflow-x-auto overflow-y-hidden"
    :style="{ borderBottom: '1px solid var(--line)' }"
    role="tablist"
  >
    <Link
      v-for="tab in tabs"
      :key="tab.key"
      :href="tab.href"
      class="px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap inline-flex items-center gap-2"
      :style="activeKey === tab.key
        ? { borderColor: 'var(--accent)', color: 'var(--ink)' }
        : { borderColor: 'transparent', color: 'var(--muted)' }"
      role="tab"
      :aria-selected="activeKey === tab.key"
    >
      {{ tab.label }}
      <span
        v-if="tab.count > 0"
        class="inline-flex items-center justify-center text-xs rounded-full px-1.5 min-w-5 h-5"
        :style="{ background: 'var(--accent)', color: 'var(--accentInk)' }"
      >
        {{ tab.count > 99 ? '99+' : tab.count }}
      </span>
    </Link>
  </div>
</template>
